import './src/styles/main.scss';
//
import './src/utils/fontawesome'; // <- ajoute les icônes
import './src/utils/fontawesome-config'; // <- désactive auto CSS

// import 'jquery/dist/jquery.min.js';
// import 'bootstrap-sass/assets/javascripts/bootstrap.min.js';
if (typeof window !== 'undefined') {
	window.jQuery = window.$ = require('jquery');
	require('bootstrap-sass/assets/javascripts/bootstrap.min.js');
}
